'use client';
import { useContext, useEffect, useRef } from 'react';
import { useRouter } from 'next/navigation';
import { useGetProjectMetadataBase, useGetUser } from '@/api/graphql';
import { AuthenticationContext } from '@/common/providers/AuthenticationProvider/AuthenticationContext';
import { Spinner } from '@/common/Spinner';
import { getElementId } from '@/common/utils/getElementId';

/**
 * Redirects to the last accessed project or organization overview
 */
const Page = () => {
  const router = useRouter();
  const { data, loading: loadingUser } = useGetUser();
  const { auth0OrgId } = useContext(AuthenticationContext);
  const hasRedirected = useRef(false);

  const lastAccessedProjectId =
    data?.getUser?.userOrgData?.lastAccessedProjectId;

  const {
    data: project,
    error,
    loading: loadingProject,
  } = useGetProjectMetadataBase({
    variables: { id: lastAccessedProjectId! },
    skip: !lastAccessedProjectId,
  });

  const domainId = getElementId(project?.getProject.domainId);

  const isLoading =
    loadingUser || (!!lastAccessedProjectId && (loadingProject || !project));

  useEffect(() => {
    if (hasRedirected.current || isLoading || !auth0OrgId) {
      return;
    }

    hasRedirected.current = true;

    const redirectPath =
      lastAccessedProjectId && domainId && !error
        ? `/organizations/${auth0OrgId}/domains/${domainId}/projects/${getElementId(
            lastAccessedProjectId
          )}/overview`
        : `/organizations/${auth0OrgId}/domains`;

    router.push(redirectPath);
  }, [auth0OrgId, domainId, error, isLoading, lastAccessedProjectId, router]);

  return <Spinner />;
};

export default Page;
